import { render } from "./foldersFiles.vue?vue&type=template&id=73b1924d"
import script from "./foldersFiles.vue?vue&type=script&lang=js"
export * from "./foldersFiles.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/grgnd.webweb.works/client/grapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__